import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/core/api/api.service';
import { SnackService } from 'app/app-wrapper/snack.service';
import { catchError } from 'rxjs';
import { passwordMatchValidator } from '../verify-user/password-repeat.validator';

import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { LayoutModule } from '@shared/directives/layout/layout.module';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'reset-password-token',
    templateUrl: './reset-password-token.component.html',
    imports: [
    ReactiveFormsModule,
    CardModule,
    ToastModule,
    ButtonModule,
    LayoutModule,
    FloatLabelModule,
    InputTextModule,
    TranslateModule
]
})
export class ResetPasswordTokenComponent implements OnInit {
    resetForm: FormGroup;
    token: string;

    constructor(
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private api: ApiService,
        private router: Router,
        private snack: SnackService
    ) {}

    ngOnInit(): void {
        // Extract the token from the route path parameter
        this.route.params.subscribe(params => {
            this.token = params['token']; // The token from the URL
        });

        this.resetForm = this.fb.group(
            {
                password: ['', [Validators.required, Validators.minLength(6)]],
                repeatpassword: ['', [Validators.required, Validators.minLength(6)]],
            },
            { validators: passwordMatchValidator }
        );
    }

    onSubmit(): void {
        if (this.resetForm.valid) {
            const password = this.resetForm.value.password;
            delete this.resetForm.value.repeatpassword;

            this.api
                .resetPasswordWithToken(this.token, password)
                .pipe(
                    catchError(err => {
                        console.log(err);
                        this.snack.showSnack(err.error.message);
                        return [];
                    })
                )
                .subscribe(() => {
                    this.snack.showSnack('Password reset successfully. Please login with your new password.');
                    this.router.navigate(['app/login']);
                });
        }
    }

    get passwordMismatchError(): boolean {
        return this.resetForm.hasError('passwordMismatch');
    }
}
